export const circleCategories = [
  {
    value: "student",
    membershipFee: 0,
    payoutFee: "2%",
    size: "10–20 members",
    amounts: "€25 / €50 / €100",
    trust: "40+",
    fsi: "Optional",
  },
  {
    value: "salaried_diaspora",
    membershipFee: 8,
    payoutFee: "3%",
    size: "10–15 members",
    amounts: "€50 / €100 / €250 / €500",
    trust: "55+",
    fsi: "€2 / month included",
  },
  {
    value: "community_family",
    membershipFee: 5,
    payoutFee: "4%",
    size: "5–10 members",
    amounts: "€100 / €250 / €500 / €1000",
    trust: "70+",
    fsi: "€2 / month included",
  },
  {
    value: "entrepreneur_business",
    membershipFee: 12,
    payoutFee: "5%",
    size: "5–10 members",
    amounts: "€100 / €250 / €500 / €1000",
    trust: "70+",
    fsi: "€2 / month included",
  },
];

export const legacyCategoryAliases = {
  etudiant: "student",
  salarie: "salaried_diaspora",
  entrepreneur: "entrepreneur_business",
};

export const normalizeCategory = (category) => legacyCategoryAliases[category] || category;
